import { ReactElement, useEffect, useRef } from 'react'
import PageLayout from '../../../components/page-layout/page-layout'
import retriveMessages, { LocaleType } from '../../../messages/message'
import { NextPageWithLayout } from '../../../common/common-types'
import { GetStaticPropsContext } from 'next'
import { useRouter } from 'next/router'
import { useTranslations } from 'next-intl'
import { getProductMeta } from '../../../common/seo'
import { EventReportManager } from '../../../event-report/event-report-manager'
import { withSEO } from '../../../common/with-seo'
import PdFloatRobot from '../../../components/pd-float-robot/pd-float-robot'
import { Section1 } from './section1'
import { Section2 } from './section2'
import { Section3 } from './section3'
import { Section4 } from './section4'
import { Section5 } from './section5'
import { Section6 } from './section6'
import useSWR from 'swr'
import { getProductBaseData, getProductDetailData, ProductDetailData } from '@/service/product'
import { MetaPage } from '@/common/meta-component-mgmt'
import { buildContactUsHref } from '../../../common/contact-us-link'

const PuduD9: NextPageWithLayout<{ productDetailData: ProductDetailData }> = ({ productDetailData }) => {
  const router = useRouter()
  const t = useTranslations()
  const reported = useRef(false)
  const { data: productBaseData } = useSWR(getProductBaseData.swrkey(router.locale || '', 'pudud9'), () =>
    getProductBaseData('pudud9')
  )
  useEffect(() => {
    const meta = getProductMeta(router.route)
    if (meta && !reported.current) {
      reported.current = true
      EventReportManager.getInstance().fireEventImmediately(
        {
          data: {
            event: 'view_item',
            item_id: meta.id,
            item_name: meta.name,
            item_category: meta.category,
          },
        },
        true
      )
    }
  }, [])

  return (
    <>
      {productBaseData?.useDescription ? (
        <MetaPage productId="pudud9" initialData={productDetailData} />
      ) : (
        <div id="pudud9" className={['bg-black', 'w-full'].join(' ')}>
          <Section1 />
          <Section2 />
          <Section3 />
          <Section4 />
          <div className="flex flex-col laptop:flex-col-reverse">
            <Section6 />
            <Section5 />
          </div>

          <PdFloatRobot
            robot={'https://cdn.pudutech.com/official-website/d9/mini_d9.webp'}
            color="#0066ff"
            href={buildContactUsHref('pudud9')}
            hideCircleBorder={true}
            buttonText={t('InquiryProducts')}
            buttonTextSize="small"
            buttonTextColor="#fff"
          />
        </div>
      )}
    </>
  )
}

export const getStaticProps = withSEO(
  async ({ locale }: GetStaticPropsContext) => {
    const messages = retriveMessages(['product-d9'], locale as LocaleType)
    const productDetailData = await getProductDetailData('pudud9')

    return {
      props: {
        messages,
        productDetailData: productDetailData || [],
      },
      revalidate: 60,
    }
  },
  () => '/products/d9'
)

PuduD9.getLayout = function (page: ReactElement, seo) {
  return (
    <PageLayout
      sticky={true}
      pageTitle={seo.title}
      pageDescription={seo.description}
      pageKeywrods={seo.keywords}
      ogtype={'website'}
    >
      {page}
    </PageLayout>
  )
}

export default PuduD9
